<template>
  <div>
    <v-btn
      @click="switchHandler"
      :disabled="!deleteActiveCondition"
      :class="styles"
      flat
      small
      icon
      color="red"
    >
      <v-icon>delete_forever</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { actions, getters } from '@/vuex/modules/pointGroupOperation/constants'
import immer from 'immer'
import deleteStyles from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/Point/deleteStyles'
import { showLabelOnHover } from '@/components/Shared/Button/iconButtonStyles'
import { cx } from 'emotion'
import cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'DeleteButton',
  props: { point: Object, withLabel: Boolean },
  computed: {
    styles() {
      return cx(
        'icon',
        deleteStyles.icon(this.point, this.deleteActiveCondition),
        this.withLabel ? showLabelOnHover('削除') : null,
      )
    },
    deleteActiveCondition() {
      const pointList = this.$store.getters[getters.initialPointList]
      const pointId = this.point.id
      const thisPointInitial = pointList.find(point => point.id === pointId)

      // 新規アイテムの場合
      if (!thisPointInitial) {
        return true
      }

      // 新規アイテムではない場合
      return (
        thisPointInitial.status === 'inactive' &&
        this.point.status === 'inactive' &&
        this.point.newItem.new === false
      )
    },
  },
  methods: {
    switchHandler() {
      if (this.point.newItem.new === false) {
        this.deleteExistingItem()
      } else if (this.point.newItem.new === true) {
        this.deleteNewItem()
      }
    },
    deleteExistingItem() {
      const point = cloneDeep(this.point)
      const data = immer(point, draft => {
        draft.toDelete = !draft.toDelete
      })
      this.$store.dispatch(actions.EDIT_GROUP_POINT, { data })
    },
    deleteNewItem() {
      this.$store.dispatch(actions.DELETE_NEW_ITEM, { data: this.point })
    },
  },
}
</script>

<style scoped lang="scss">
.icon {
  color: #448aff;
  cursor: pointer;
  user-select: none;
}
</style>
